import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../../../constants/common'
import { USER_FORM_FIELD_NAME_MESSAGE } from '../../../../../User'

import { MESSAGE_FIELD_ERROR_NOTIFICATION_ID } from './useMessageFieldErrorNotification.constants'

export function useMessageFieldErrorNotification({
  errors,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()

  useEffect(() => {
    if (errors[USER_FORM_FIELD_NAME_MESSAGE]) {
      onSetNotification({
        id: MESSAGE_FIELD_ERROR_NOTIFICATION_ID,
        text: t(errors[USER_FORM_FIELD_NAME_MESSAGE]),
        type: NOTIFICATION_TYPE.error,
      })
    } else {
      onRemoveNotification(MESSAGE_FIELD_ERROR_NOTIFICATION_ID)
    }
  }, [errors])
}
